import { IActiveIngestion } from 'Modules/Studio/components/StudioInfo/redux/ingestion.interface';
import { INGESTION_BY_TABLE_TEXT } from '../../../IngestionByDataSource.constants';
import { INGESTION_CONSTANTS } from 'Modules/Studio/components/StudioInfo/Ingestion/utilities/Ingestion.constants';

/**
 * Returns the tooltip text to display for the table view datasource ingestion button
 * @param isDisabled
 * @param isRunning
 * @returns string
 */
export const getTableViewDataSourceToolTipText = (
  isDisabled: boolean,
  isRunning: boolean
): string => {
  if (isDisabled) {
    return INGESTION_BY_TABLE_TEXT.tooltips.disabled.stopping;
  }

  return isRunning
    ? INGESTION_BY_TABLE_TEXT.tooltips.stopDS
    : INGESTION_BY_TABLE_TEXT.tooltips.startDS;
};

/**
 * Returns whether the table view datasource ingestion button should be disabled based on the active ingestion status
 * either at the datasource level or table level(s) (if all are stopping)
 * @param activeIngestion
 * @returns boolean
 */
export const getTableViewDataSourceIsDisabled = (
  activeIngestion: IActiveIngestion | null
): boolean => {
  if (!activeIngestion) {
    return false;
  }

  const activeTables: string[] = Object.keys(activeIngestion.tables || {});

  // If ingestion is stopping at datasource level
  if (activeIngestion.tables && activeTables.length === 0) {
    return activeIngestion.status === INGESTION_CONSTANTS.TRIGGERED_STOP;
  }

  // If ingestion is stopping at table level(s)
  const tableStatuses = Object.values(activeIngestion.tables || {}).map((table) => table.status);
  return tableStatuses.every((status) => status === INGESTION_CONSTANTS.TRIGGERED_STOP);
};
